// extracted by mini-css-extract-plugin
export default {"rocket":"Rocket_rocket__HXE7K","badge":"Rocket_badge__PtZn2","cancelBtn":"Rocket_cancelBtn__l2vk5","reserveBtn":"Rocket_reserveBtn__VpJZF"};